import AdSlot from './components/AdSlot';
const BlogsBottomAds = () => {
    return (
        <div className="blogs_bottom_ads">
            <AdSlot
                slotKey="blogs_bottom_ad"
                containerClass="blogs_bottom_ad"
                className="blogs_bottom_ad_image"
                id="blogs_bottom_ad"
            />
        </div>
    );
};

const BlogsSideAds = () => {
    return (
        <AdSlot
            slotKey="blogs_side_ad"
            containerClass="blogs_side_ads"
            className="blogs_side_ad_image"
            id="blogs_side_ad"
        />
    );
};


export { BlogsBottomAds, BlogsSideAds };
